import PolypaneIntro from "../../../../src/components/PolypaneIntro";
import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import netflixdrm from "../../../../assets/images/blogs/pp251/netflix-drm.jpg";
import webcomponents251 from "../../../../assets/images/blogs/pp251/webcomponents.png";
import linkissues from "../../../../assets/images/blogs/pp251/linkissues.png";
import robotsmeta from "../../../../assets/images/blogs/pp251/robotsmeta.png";
import * as React from 'react';
export default {
  PolypaneIntro,
  ShortCutDisplay,
  netflixdrm,
  webcomponents251,
  linkissues,
  robotsmeta,
  React
};